import _extends from "@babel/runtime-corejs3/helpers/extends";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/slice";
import _spliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/splice";
import _trimInstanceProperty from "@babel/runtime-corejs3/core-js/instance/trim";
import { isText } from 'intact-vue-next';
import { isStringOrNumber, isString, isNullOrUndefined, isInvalid, hasOwn } from 'intact-shared';
// @reference https://github.com/andreypopp/autobind-decorator/blob/master/src/index.js
// for loose mode
export function bind(target, key, descriptor) {
  var method = descriptor.value;
  // In IE11 calling Object.defineProperty has a side-effect of evaluating the
  // getter for the property which is being replaced. This causes infinite
  // recursion and an "Out of stack space" error.
  var definingProperty = false;
  return {
    configurable: true,
    get: function get() {
      if (definingProperty || this === target || /* get method from prototype */
      this.hasOwnProperty('constructor') /* get method from prototype, e.g. super call */) {
        return method;
      }
      var value = method.bind(this);
      definingProperty = true;
      Object.defineProperty(this, key, {
        value: value,
        configurable: true,
        writable: true
      });
      definingProperty = false;
      return value;
    },
    set: function set(value) {
      Object.defineProperty(this, key, {
        value: value,
        configurable: true,
        writable: true
      });
    }
  };
}
// class A {
// @bind
// hello() {
// console.log('A hello', this);
// }
// @bind
// test() {
// console.log('A test', this);
// }
// }
// const test1 = A.prototype.hello;
// test1();
// const test2 = (new A()).hello;
// test2();
// class B extends A {
// @bind
// hello() {
// super.hello();
// console.log('B hello', this);
// }
// }
// class C extends B {
// @bind
// test() {
// super.test();
// console.log('C test', this);
// }
// }
// const b = new B();
// const c = new C();
// const hello = b.hello;
// const test = c.test;
// hello();
// test();
export function addStyle(style, extra) {
  if (!style) return extra;
  if (!extra) return style;
  if (typeof style === 'string') {
    var _context;
    var _extra = _mapInstanceProperty(_context = _Object$keys(extra)).call(_context, function (key) {
      return kebabCase(key) + ": " + extra[key];
    }).join(';');
    style = "" + style + (!style || /;\s*$/.test(style) ? '' : ';') + _extra;
  } else {
    style = _extends({}, style, extra);
  }
  return style;
}
export function cache(callback) {
  var _cache = {};
  var fn = function fn() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var cacheId = args.join('~');
    if (!hasOwn.call(_cache, cacheId)) {
      _cache[cacheId] = callback.apply(void 0, args);
    }
    return _cache[cacheId];
  };
  fn.clearCache = function () {
    return _cache = {};
  };
  return fn;
}
var uppercasePattern = /[A-Z]/g;
export var kebabCase = cache(function (word) {
  return word.replace(uppercasePattern, function (item) {
    return "-" + item.toLowerCase();
  });
});
export function isTextChildren(o) {
  if (isStringOrNumber(o)) return true;
  if (Array.isArray(o)) {
    return o.every(function (item) {
      return isTextChildren(item);
    });
  }
  return isTextVNode(o);
}
export function isTextVNode(o) {
  return o && isText(o);
}
// for detect if it is a text node in Angular
export function isTextBlock(o) {
  return isTextChildren(o) || o && o.tag && o.tag.$id === 'AngularBlockWrapper' && o.props.isText;
}
export function isStringOrNumberNotEmpty(o) {
  var type = typeof o;
  return type === 'string' && !/^\s+$/.test(o) || type === 'number';
}
export function getRestProps(component, props) {
  if (props === void 0) {
    props = component.get();
  }
  var Ctor = component.constructor;
  var typeDefs = Ctor.typeDefs;
  var events = Ctor.events;
  var ret = {};
  for (var key in props) {
    switch (key) {
      case 'key':
      case 'ref':
      case 'className':
      case 'children':
        continue;
      default:
        if (key[0] === '$' || typeDefs && key in typeDefs || events && key.substr(3) in events || key.substr(0, 4) === 'ev-$') {
          continue;
        }
        ret[key] = props[key];
        break;
    }
  }
  return ret;
}
var externalLinkReg = /^(https?:)?\/\//;
export function isExternalLink(to) {
  if (!isString(to)) return false;
  return externalLinkReg.test(to);
}
export function clamp(number, lower, upper) {
  return Math.min(Math.max(number, lower), upper);
}
export function stopPropagation(e) {
  e.stopPropagation();
}
export function findChildren(children, callback) {
  var found = undefined;
  if (isInvalid(children)) return found;
  var index = -1;
  var loop = function loop(children) {
    if (Array.isArray(children)) {
      for (var i = 0; i < children.length; i++) {
        var vNode = children[i];
        if (isInvalid(vNode)) continue;
        if (loop(vNode)) {
          found = vNode;
          return true;
        }
      }
    } else if (callback(children, ++index)) {
      found = children;
      return true;
    }
    return false;
  };
  loop(children);
  return found;
}
export function mapChildren(children, callback) {
  var results = [];
  findChildren(children, function (vNode, index) {
    results.push(callback(vNode, index));
    return false;
  });
  return results;
}
export function eachChildren(children, callback) {
  findChildren(children, function (vNode, index) {
    callback(vNode, index);
    return false;
  });
}
// mapChildren(['a', null, 'b', ['c', 'd', ['e', null,  'f'], 'g'], 'h'], (a, b) => console.log(a, b));
export function toggleArray(arr, value) {
  if (!Array.isArray(arr)) {
    return [value];
  } else {
    arr = _sliceInstanceProperty(arr).call(arr, 0);
    var index = arr.indexOf(value);
    if (~index) {
      _spliceInstanceProperty(arr).call(arr, index, 1);
    } else {
      arr.push(value);
    }
    return arr;
  }
}
export function getTextByChildren(children) {
  var ret = '';
  if (isInvalid(children)) return ret;
  if (Array.isArray(children)) {
    children.forEach(function (vNode) {
      ret += getTextByChildren(vNode);
    });
  } else if (isStringOrNumber(children)) {
    ret += children;
  } else if (isTextVNode(children)) {
    ret += children.children;
  }
  return _trimInstanceProperty(ret).call(ret);
}
export function isEmptyString(o) {
  return isNullOrUndefined(o) || o === '';
}
export function isEmptyChildren(o) {
  return isEmptyString(o) || Array.isArray(o) && o.every(function (item) {
    return isEmptyChildren(item);
  });
}
export function isComponentVNode(o, tag) {
  return o.tag === tag;
}
export function range(start, end) {
  var _context2;
  return _mapInstanceProperty(_context2 = Array.apply(null, {
    length: end - start + 1
  })).call(_context2, function (v, i) {
    return i + start;
  });
}
export function strPad(str, length, pad) {
  if (pad === void 0) {
    pad = '0';
  }
  str = str.toString();
  var l = str.length;
  if (l < length) {
    str = new Array(length - l + 1).join(pad) + str;
  }
  return str;
}
/**
 * 在vue3.0中，数组会转成Proxy对象，需要获取原始数据比较
 * https://github.com/ksc-fe/kpc/issues/985
 * https://github.com/vuejs/core/blob/main/packages/reactivity/src/reactive.ts
 */
var RAW = '__v_raw';
function isProxy(value) {
  return value ? !!value[RAW] : false;
}
function toRaw(observed) {
  var raw = observed && observed[RAW];
  return raw ? toRaw(raw) : observed;
}
export function isEqualArray(a, b) {
  if (a === b) return true;
  // for vue3.0 Proxy object
  if (isProxy(a)) a = toRaw(a);
  if (isProxy(b)) b = toRaw(b);
  if (a === b) return true;
  if (Array.isArray(a) && Array.isArray(b)) {
    if (a.length !== b.length) return false;
    return a.every(function (value, index) {
      return isEqualArray(value, b[index]);
    });
  }
  return false;
}
export function isEqualObject(a, b) {
  if (a === b) return true;
  if (a && b) {
    var keysA = _Object$keys(a);
    var keysB = _Object$keys(b);
    if (keysA.length !== keysB.length) return false;
    return keysA.every(function (key) {
      return a[key] === b[key];
    });
  }
  return false;
}
export function last(arr) {
  return arr[arr.length - 1];
}
export var expandAnimationCallbacks = {
  'name': 'k-expand',
  'onLeave': function onLeave(el) {
    var height = el.clientHeight;
    el.style.height = height + "px";
    nextFrame(function () {
      el.style.height = "0px";
    });
  },
  'onAfterLeave': function onAfterLeave(el) {
    el.style.height = '';
  },
  'onBeforeEnter': function onBeforeEnter(el) {
    // we should set the enter el's height to 0
    // otherwise it will affect the movable el's position 
    el.style.height = "0px";
  },
  'onEnter': function onEnter(el) {
    el.style.height = '';
    var height = el.clientHeight;
    el.style.height = "0px";
    nextFrame(function () {
      el.style.height = height + "px";
    });
  },
  'onAfterEnter': function onAfterEnter(el) {
    el.style.height = '';
  }
};
export function throttle(fn, time, doAlways) {
  var lock = false;
  var timer;
  return function (arg) {
    if (doAlways) doAlways(arg);
    if (lock) return;
    lock = true;
    timer = window.setTimeout(function () {
      fn(arg);
      lock = false;
    }, time);
  };
}
export function debounce(fn, time, immediately) {
  if (immediately === void 0) {
    immediately = false;
  }
  var timer;
  var lock = !immediately;
  return function () {
    if (!lock) {
      lock = true;
      return fn();
    }
    window.clearTimeout(timer);
    timer = window.setTimeout(function () {
      fn();
      lock = !immediately;
    }, time);
  };
}
export function nextFrame(fn) {
  requestAnimationFrame(function () {
    requestAnimationFrame(fn);
  });
}
export function selectValue(elem) {
  if (elem.select) {
    elem.select();
  } else if (elem.setSelectionRange) {
    // mobile safari
    elem.focus();
    elem.setSelectionRange(0, elem.value.length);
  }
}
export function swap(list, from, to) {
  var newList = _sliceInstanceProperty(list).call(list, 0);
  var item = _spliceInstanceProperty(newList).call(newList, from, 1)[0];
  _spliceInstanceProperty(newList).call(newList, to, 0, item);
  return newList;
}